<template>
  <div>
    <div class="page-header page-header-big">
      <parallax
        class="page-header-image2"
        style="background-image: url('img/baby.jpg');  " 
      >
      </parallax>
   
    </div>

  <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
               <h2 class="title" id="test">{{$t('chiara_welcome')}}<span style="color:#fb6f70;"> {{$t('chiara_welcome2')}}</span></h2>
            
            <h4 class="description"  style="color:black;" v-html= "$t('chiara_welcome3')">
              
            </h4>
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-3 equal">
                <img src="img/cal.png" alt="" srcset="" width="100%">
            </div>
             <div class="col-md-3 equal">
                <img src="img/when.png" alt="" srcset="" >

            </div>
            <div class="col-md-3 equal">
                <img src="img/tons.png" alt="" srcset="" >
            </div>
             <div class="col-md-3 equal">
                <img src="img/len.png" alt="" srcset=""  >

            </div>
          </div>
        </div>

        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/chiara1.jpg')"
              >
               <p class="chiarablockquote blockquote-primary">
                 {{$t('chiara_frase')}}
                 
                  <br />
                  <br />
                  <small>{{$t('chiara_santa')}}
</small>
                </p>
              
                <!-- First image on the left side -->
              <!--   <div class="row">
                  <div class="col-md-12">
                      <p class="chiarablockquote blockquote-primary">
                        <img src="img/cal.png" alt="" srcset="" width="50%">
                        <img src="img/when.png" alt="" srcset="" width="50%">
                      </p> 
                  </div>
                </div> -->
               
              </div>
              <!-- Second image on the left side of the article -->
              <!-- <div
                class="image-container"
                style="background-image: url('img/FamigliaMartino.png')"
              ></div> -->
            </div>
            
            <div class="col-md-5" id="lista">
              <!-- First image on the right side, above the article -->
              <div
                class="image-container image-right"
                style="background-image: url('img/chiara2.jpg')"
              ></div>
              <!-- <div class="row">
                <div class="col-md-12 ">
                      <p class="text-justify chiara_color" >
                        <img src="img/cal.png" alt="" srcset="" width="50%">
                        <img src="img/when.png" alt="" srcset="" width="50%">
                      </p> 
                </div>
              </div> -->
              <br>
              <br>
              <div style="text-align:center" >
              <h3>
              {{$t('chiara_intro_title')}}
              </h3>
              </div>
               
              <p class="text-justify" v-html="$t('chiara_intro')" >

              </p>
            </div>
          </div>
        
          <!-- cosa regalarci---------------------------------------------------------  -->

          <div class="row" id="what">
           <div class="col-md-6 ml-auto mr-auto text-center">
             <img src="img/hearths.png" alt="" srcset="" style="padding-bttom:50px;">
            </div>
           
             <div class="col-md-6 ml-auto mr-auto text-center">
             <img src="img/FamigliaMartino.png" alt="" srcset="" width="80%" style="padding-top:100px;">

            </div>
          </div>
          <!-- fine cosa regalarci --------------------------------------------------- -->
          <div class="row">
            <div class="col-md-10  ml-auto mr-auto text-center">
             <img src="img/qr-code.png" alt="" srcset="" width="30%" style="padding-top:40px;">
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <!-- <div class="section text-center">
      <div class="container"> -->
        

    <!--   </div>
    </div> -->
       
<!--     <div class="section section-team text-center">
      <div class="container">
        <h2 class="title" id="team">{{$t('team')}}</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-6">
              <div class="team-player">
                <img
                  src="img/io.jpeg"
                  alt="Martina Barakova"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Martina Barakova</h4>
                <p class="category text-primary">{{$t('marti_desc')}}</p>
                <p class="description">
                  {{$t("marti")}}
                  <random-chart></random-chart>
                </p>
            
              </div>
            </div>
            <div class="col-md-6">
              <div class="team-player">
                <img
                  src="img/lei.jpeg"
                  alt="Leonardo Martino"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Leonardo Martino</h4>
                <p class="category text-primary">{{$t('leo_desc')}}</p>
                <p class="description">
                  {{$t("leo")}}
                </p>
            
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>  -->
     
    
   
  </div>
  
</template>
<script>
const querystring = require("querystring");


import { Button, Badge, FormGroupInput,Checkbox, Tabs, Card,TabPane } from '@/components';
import Countdown from '../components/Countdown.vue';
import myGallery from '../components/myGallery.vue';
import Youtube from "../components/Youtube.vue";
import RandomChart from '../components/Charts/RandomChart.vue';
/* import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet' */


export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [Badge.name]: Badge,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,
    Countdown,
    myGallery,
    RandomChart,
    Card,
    Tabs,
    TabPane,
    Youtube
   /*  LMap,
    LTileLayer,
    LMarker,
    LPopup */
    
  },
  data() {
    return {
      videoId:'8JCuQhUlRPk',
      sent: false,
      form: {
        firstName: '',
        email: '',
        message: '',
        si:false,
        no:false,
        numbers:'',
        host:false,
        seven:false,
        eight:false,
        veg:false,
        veg_n:'',
        cel:false,
        cel_n:'',
        baby:false,
        baby_n:'',
        altro:''
        
      },
      /* map:null,
      tabMaps:[],
      zoomControl: false,
      attributionControl: false,
      zoom:13,
      center: L.latLng(49.1945619,16.5965591),
      url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
      	{
          id:"0",
          position: L.latLng(49.1945619,16.5965591),
          text:  this.$i18n.t('table[9]')
        },
        {
          id:"1",
          position: L.latLng(49.1926016, 16.5634350),
          text: this.$i18n.t('table[10]')
        },
     ] */
     
     
      

     
                  
                
      
     
  
    };
  },
  methods: {
      onSubmit(e) {
          e.preventDefault();
          console.log(this.form)
           this.$axios
             .post(
                 "https://martinofamily.eu/mail.php",
                  querystring.stringify(this.form)
             )
             .then(res => {
                 this.sent = true;
             }) ;
      }
      
    /* openPopup: function (event) {
      this.$nextTick(() => {
          event.target.openPopup();
      }) 
    }*/
    // invalidateSize: function(tabIndex) {
     
     /*  setTimeout(() => {
        if (typeof tabIndex === "number") {
          this.tabMaps[tabIndex].invalidateSize();
        } else {
          // invalidate all maps
          this.tabMaps.forEach(map => {
            map.invalidateSize();
          });
        }
      }, 10); */
     
  },
  
  mounted() {
    /* this.map = L.map('map').setView([49.1979304,16.6054659], 19);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
    var marker = L.marker([49.1979304,16.6054659]).addTo(this.map);
    
    marker.bindPopup(L._("table[9]"));


    this.tabMaps.push(this.map); // 0 */
    //this.invalidateSize();
          //setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 20);

  }
 
};
</script>
<style></style>

